import { Slider as SliderMUI, styled } from '@mui/material';

import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';

export type SliderProps<T extends FieldValues> = UseControllerProps<T> & {
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
};

const StyledSliderRow = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
  width: '100%',
}));

const StyledSlider = styled(SliderMUI)({
  flex: 1,
  color: 'var(--button-button-primary-color)',
});

const StyledValue = styled('span')(({ theme }) => ({
  minWidth: theme.spacing(7),
  fontSize: 14,
  fontWeight: 500,
  color: 'var(--text-text-secondary-color)',
  textAlign: 'right',
}));

export const Slider = <T extends FieldValues>({
  name,
  control,
  min = 0,
  max = 1,
  step = 0.1,
  disabled,
}: SliderProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const value = typeof field.value === 'number' ? field.value : min;

        return (
          <StyledSliderRow>
            <StyledSlider
              value={value}
              onChange={(_, newValue) => field.onChange(newValue as number)}
              min={min}
              max={max}
              step={step}
              disabled={disabled}
              valueLabelDisplay="auto"
            />
            <StyledValue>{value.toFixed(1)}</StyledValue>
          </StyledSliderRow>
        );
      }}
    />
  );
};
